<ng-container *ngIf="card">
    <div class="btr-hours-card">
        <div class="btr-hours-card__header">
            <app-btr-section-title [headingId]="cardId + '_title'" [step]="step" [text]="card.title"></app-btr-section-title>
            <ng-container *ngIf="card.statusLabel">
                <app-ds-badge size="sm" theme="gray" [label]="card.statusLabel"></app-ds-badge>
            </ng-container>
        </div>

        <table class="btr-hours-card__table">
            <thead>
                <tr>
                    <th class="btr-hours-card__column-title" scope="col">Leg</th>
                    <th class="btr-hours-card__column-title" scope="col">Airport / routing</th>
                    <th class="btr-hours-card__column-title btr-hours-card__hours" scope="col">Hours</th>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngFor="let row of card.legs; trackBy: trackByLeg">
                    <tr>
                        <th scope="row">
                            <div class="btr-hours-card__leg">
                                <ds-text size="sm" weight="semibold" theme="primary" [text]="row.title"></ds-text>
                                <ds-text size="xs" weight="regular" theme="secondary" [text]="row.subtitle"></ds-text>
                                <ng-container *ngIf="isActual && row.leg === ibLeg">
                                    <ng-content select="[ibRepoStatus]"></ng-content>
                                </ng-container>
                            </div>
                        </th>

                        <ng-container *ngIf="isActual && hoursGroup; else readonlyLeg">
                            <td [formGroup]="hoursGroup">
                                <ng-container *ngIf="legControls[row.leg].isAirport; else routingInput">
                                    <ds-select
                                        [id]="cardId + '_' + row.leg + '_place'"
                                        [formControlName]="legControls[row.leg].placeControl"
                                        [ariaLabel]="row.title + ' airport'"
                                        placeholder="Select airport"
                                        [isSearchable]="true"
                                        [isClearable]="true"
                                        [options]="airportOptions"
                                        [compareWith]="compareById"
                                    ></ds-select>
                                </ng-container>
                                <ng-template #routingInput>
                                    <ds-input
                                        [id]="cardId + '_' + row.leg + '_place'"
                                        [formControlName]="legControls[row.leg].placeControl"
                                        [ariaLabel]="row.title + ' routing'"
                                        placeholder="Routing"
                                    ></ds-input>
                                </ng-template>
                            </td>
                            <td class="btr-hours-card__hours" [formGroup]="hoursGroup">
                                <ds-input
                                    [id]="cardId + '_' + row.leg + '_hours'"
                                    [formControlName]="legControls[row.leg].hoursControl"
                                    [ariaLabel]="row.title + ' hours'"
                                    type="number"
                                    min="0"
                                    placeholder="0.00"
                                >
                                    <span suffix>hrs</span>
                                    <mat-error>{{ hoursError }}</mat-error>
                                </ds-input>
                            </td>
                        </ng-container>

                        <ng-template #readonlyLeg>
                            <td>
                                <div class="btr-hours-card__place">
                                    <ds-text size="md" weight="regular" theme="primary" [text]="row.place"></ds-text>
                                    <ng-container *ngIf="row.plannedPlace">
                                        <app-ds-badge size="sm" theme="warning" [label]="row.plannedPlace"></app-ds-badge>
                                    </ng-container>
                                </div>
                            </td>
                            <td class="btr-hours-card__hours">
                                <ds-text size="md" weight="semibold" theme="primary" [text]="row.hours"></ds-text>
                            </td>
                        </ng-template>
                    </tr>
                </ng-container>

                <ng-container *ngIf="isActual && isCancellationVisible">
                    <tr>
                        <th scope="row">
                            <div class="btr-hours-card__leg">
                                <ds-text size="sm" weight="semibold" theme="primary" text="Cancellation"></ds-text>
                            </div>
                        </th>
                        <td></td>
                        <ng-container *ngIf="hoursGroup; else readonlyCancellation">
                            <td class="btr-hours-card__hours" [formGroup]="hoursGroup">
                                <ds-input
                                    [id]="cardId + '_cancellation_hours'"
                                    formControlName="cancellationHours"
                                    ariaLabel="Cancellation hours"
                                    type="number"
                                    min="0"
                                    placeholder="0.00"
                                >
                                    <span suffix>hrs</span>
                                    <mat-error>{{ hoursError }}</mat-error>
                                </ds-input>
                            </td>
                        </ng-container>
                        <ng-template #readonlyCancellation>
                            <td class="btr-hours-card__hours">
                                <ds-text size="md" weight="semibold" theme="primary" [text]="cancellationHours"></ds-text>
                            </td>
                        </ng-template>
                    </tr>
                </ng-container>
            </tbody>
        </table>

        <ng-content select="[ibRepoPanel]"></ng-content>

        <div class="btr-hours-card__total">
            <ds-text
                class="btr-hours-card__total-label"
                size="sm"
                weight="semibold"
                [color]="titleColor"
                [text]="card.totalLabel"
            ></ds-text>
            <ng-container *ngIf="card.isIbExcluded">
                <ds-text size="xs" weight="regular" theme="secondary" [text]="notCountedText"></ds-text>
            </ng-container>
            <ng-container *ngIf="card.variance">
                <app-ds-badge size="sm" [theme]="card.variance.theme" [label]="card.variance.label"></app-ds-badge>
            </ng-container>
            <ng-container *ngIf="!isActual && hoursGroup; else totalText">
                <div class="btr-hours-card__total-input" [formGroup]="hoursGroup">
                    <ds-input
                        [id]="cardId + '_total'"
                        formControlName="estimatedBlockHours"
                        [ariaLabel]="card.totalLabel"
                        type="number"
                        min="0"
                        placeholder="0.00"
                    >
                        <span suffix>hrs</span>
                        <mat-error>{{ hoursError }}</mat-error>
                    </ds-input>
                </div>
            </ng-container>
            <ng-template #totalText>
                <ds-text size="lg" weight="bold" [color]="titleColor" [text]="card.totalHours + ' hrs'"></ds-text>
            </ng-template>
        </div>
    </div>
</ng-container>
